const doc = [({"da":({"js":({"users":({"settings":({"settings":"Indstillinger", "user_information":"Bruger oplysninger:"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;